import { db } from 'src/config/firebase';

const getReviews = async (serviceId,queryBy) => {
  try {
    const snapshot = await db
      .ref('Reviews')
      .orderByChild(queryBy || 'serviceId')
      .equalTo(serviceId)
      .once('value');
    const data = await snapshot.val();

    const arr = [];
    for (const val in data) {
      if(data[val]?.visible === undefined || data[val]?.visible) {
        arr.push(data[val]);
      }
    }
    return arr.reverse();
  } catch (error) {
    console.warn('Error fetching reviews: ', error.message);
  }
};

export default getReviews;
